import React, { useState, useEffect, useCallback } from 'react';
import { Spinner } from 'react-bootstrap';
import CheckboxTree from 'react-checkbox-tree';
import api from '../../../api';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import '../../../../node_modules/font-awesome/css/font-awesome.min.css'; 

function CategoryList(props) {

    const { eventID, selectedKeys, expandedKeys, onExpand, onSelect } = props;
    const [ productCategories, setCategories ] = useState([]);
    const [ loading, setLoading ] = useState(true);

     /**
     * Fetch products.
     *
     * @param {string} search
     */
    const handleChildCategories = useCallback((children, index) => {
        if (children.length) {
            children = children.map((child) => {
                let returnValue = {
                    value: child.productCategoryId,
                    label: child.name,
                    children: child.childCategories && child.childCategories.length ? handleChildCategories(child.childCategories.length) : []
                }

                if (!returnValue.children.length) {
                    delete returnValue.children
                }

                return returnValue
            })
        }
        return children
    }, [])

    const _fetchCategories = useCallback((page) => {
        setLoading(true);
        api.shop.getProductCategories(eventID)
            .then(response => {
                let productCategories = response.data.data.productCategories.map((category, index) => {
                    let returnValue = {
                        value: category.productCategoryId,
                        label: category.name,
                        children: handleChildCategories(category.childCategories, index)
                    }

                    if (!returnValue.children.length) {
                        delete returnValue.children
                    }

                    return returnValue
                });
                setCategories(productCategories);
                onExpand(productCategories.map((category) => {
                    return category.value
                }))
        })
        .finally(() => {
            setLoading(false);
        });

        return () => {
            setLoading(true);
            setCategories([]);
        }
    }, [eventID, handleChildCategories, onExpand]);

    /**
     * Fetch products on component mount.
     */
    useEffect(() => {
        _fetchCategories()
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return(
        !loading ?
            <React.Fragment>
                <div className="CategoryList">
                    { productCategories.length > 0 ?
                        <CheckboxTree
                            onExpand={expanded => onExpand(expanded)}
                            expanded={expandedKeys}
                            checked={selectedKeys}
                            onCheck={checked => onSelect(checked)}
                            showNodeIcon={false}
                            nativeCheckboxes={true}
                            nodes={productCategories}
                            >
                            {/* {renderTreeNodes(productCategories)} */}
                        </CheckboxTree>
                        :
                        <div>
                            Ei tuotekategorioita.
                        </div>
                    }

                </div>
            </React.Fragment>
        :
        <div className="text-center" style={{ padding: '30px'}}>
            <Spinner animation="border" role="status" variant="primary">
                <span className="sr-only">Loading...</span>
            </Spinner>
        </div>
    )
}

export default CategoryList;